import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RATING_STATUS_DECLARATION, getConfig, FEEDBACK_STATUS_MAPPING, FEEDBACK_STATUS_COLOR_MAPPING, RATING, getLottieConfig } from 'src/app/core/constants/app-constants';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from '../../service/order.service';
import { ThankyouForRatingModalComponent } from '../thankyou-for-rating-modal/thankyou-for-rating-modal.component';
import { AppData } from 'src/app/shared';

@Component({
  selector: 'app-rating-modal',
  templateUrl: './rating-modal.component.html',
  styleUrls: ['./rating-modal.component.scss'],
})
export class RatingModalComponent implements OnInit {

  @Input() modalObj: any;
  @Input() selectedRating;
  ratingObj = {};
  rateBdrIcon = "assets/icon/rate/rate-star-grey-border.svg";
  rateYellowIcon = "assets/icon/rate/rate-star-yellow.svg";
  starsList = [0, 1, 2, 3, 4];
  isYouLikeMost = true;
  outletObj;
  statusList = RATING_STATUS_DECLARATION;
  feedback = '';
  @Output() passRating: EventEmitter<any> = new EventEmitter();
  comments = '';
  textToShow = "How's your delivery experience?";
  likeMostTxt = 'What did you like most?';
  descText = '';
  feedbackColor = '';
  statusData: string[] = [];
  selectedStatus:string[]= [];
  rows = 0;
  lottieConfig;
  options: any = {
    path: 'assets/lotties-files/star_animation.json',
  };
  statusBarHeight = AppData.statusBarHeight;
  imageType = false;
  lotties = [];
  date = new Date();
  styleObject = {};

  constructor(
    private orderService: OrderService,
    private modalService: NgbModal,
    private router: Router
  ) { 
    this.lottieConfig = getLottieConfig('STAR_ANIMATION_LOTTIE_CONFIG');
    console.log("lottie ",this.lottieConfig)
  }

  ngOnInit() {
    console.log(this.statusList)
    this.outletObj = this.modalObj;
    RATING_STATUS_DECLARATION.statusOfDelivery.map(status => status['selectItem'] = false);
    RATING_STATUS_DECLARATION.process.map(status => status['selectItem'] = false);

    const splitStr = this.outletObj.outletName.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    const outletName = splitStr.join(' ');
    this.descText = 'Rate your experience with ' + outletName + ' to Improve their service';

    if (this.selectedRating) {
      const selectedRating = Number(this.selectedRating) - 1;
      setTimeout(() => {
        this.onRatingClick(selectedRating);
      }, 800);
    }

    

  }

  feedbackIndex(index) {
    return FEEDBACK_STATUS_MAPPING[index+1];
  }

  onRatingClick(rat) {
    
    console.log("rating rat",rat)
    const rating = rat + 1;
    
    let feedbackOption = ''
    
    for (let i = 0; i < this.starsList.length; i++) {
      const feedbackText = 'feedback' + String(i);
      let text = document.getElementById(feedbackText);

      if(i == rat) {
        text.style.display = 'block';
      } else {
        text.style.display = 'none';
      }
      
      const ind = 'rate' + String(i);
      // console.log("ind ",ind)
      if (i <= rat) {
        this.lotties.push(i)
        document.getElementById(ind)['src'] = this.rateYellowIcon;
        // console.log(document.getElementById(ind)['src'] = this.rateYellowIcon);
      } else {
        document.getElementById(ind)['src'] = this.rateBdrIcon;                       
      }
    }
    
    
    // for (let i = 0; i < this.starsList.length; i++) {
    //   const ind = 'rate' + String(i);
    //   console.log("ind ",ind)
    //   if (i <= rat) {
    //     document.getElementById(ind)['src'] = this.rateYellowIcon;
    //   } else {
    //     document.getElementById(ind)['src'] = this.rateBdrIcon;
    //   }
    // }

    // if (this.isYouLikeMost) {
    //   this.ratingObj['foodRating'] = rating;
    //   this.likeMostTxt = rating < 3 ? 'What went wrong?' : 'What did you like most?';
    // } else {
    //   this.ratingObj['deliveryRating'] = rating;
    //   this.likeMostTxt = rating < 3 ? 'And is there any delivery issue?' : 'What did you like most?';
    // }
    this.ratingTextStyleObject(rat);
    this.likeMostText(rating);
    
    this.feedback = FEEDBACK_STATUS_MAPPING[rating];
    this.feedbackColor = FEEDBACK_STATUS_COLOR_MAPPING[this.feedback];
    console.log("feedback", this.feedback);

    if(rating < 3){
      feedbackOption = 'BAD_RATTING';
      this.statusData = RATING[feedbackOption];
    } else if(rating == 3 || rating == 4){
      feedbackOption = 'AVERAGE_RATING';
      this.statusData = RATING[feedbackOption];
    } else{
      feedbackOption = 'GOOD_RATING';
      this.statusData = RATING[feedbackOption]
    }
    this.selectedStatus = [];
    console.log(this.statusData)
    console.log(this.starsList)
  }

  likeMostText(rating){
    this.ratingObj['deliveryRating'] = rating;
    if(rating <= 3){
      this.likeMostTxt = 'What went wrong?'
    } else if(rating == 4){
      this.likeMostTxt = 'How can we get 5 stars?'
    } else{
      this.likeMostTxt = 'What did you like most?'
    }
  }

  ratingTextStyleObject(rating){
    let starsRating = 'rate'+rating;
    let marLeft: any;
    console.log("starsRating ",starsRating);
    let starsId: any = 0;
    let stars = document.getElementsByClassName("stars");
    for(let i = 0; i<stars.length; i++){
      console.log(stars[i].id)
      // starsId= stars[i].id
      if(starsRating == stars[i].id){
        marLeft = stars[i];
      }

    }
    // console.log(stars.length);
    console.log(stars);
  }

  status(index) {
    RATING_STATUS_DECLARATION.process[index]['selectItem'] = !RATING_STATUS_DECLARATION.process[index]['selectItem'];
  }

  isStatusSelected(status){
    return this.selectedStatus.find(p=> p == status);
  }

  rateType(status) {
    console.log(status);
    // RATING_STATUS_DECLARATION.statusOfDelivery[index]['selectItem'] = !RATING_STATUS_DECLARATION.statusOfDelivery[index]['selectItem'];
    // console.log(RATING_STATUS_DECLARATION.statusOfDelivery[index]['selectItem']);
    //RATING[index]['selectItem'] = ! RATING[index]['selectItem'];
    if(!this.selectedStatus.length){
      this.selectedStatus.push(status);
    }
    else{
      let index = this.selectedStatus.findIndex(p=> p == status);
      console.log(index)
      if(index == -1){
        this.selectedStatus.push(status);
      }
      else{
        this.selectedStatus.splice(index,1);
      }
    }
  }

  onContinue() {
    this.isYouLikeMost = false;
    this.feedback = '';
    this.textToShow = 'How was your Delivery experience?'
    this.likeMostTxt = 'What did you like most?';
    this.descText = 'Rate your experience with our Delivery Executive! This enables us to help improve their services.';
  }

  onSubmit() {
    console.log(this.selectedStatus);
    const reqBody = {
      orderId: this.outletObj.orderId,
      orderNum: this.outletObj.orderNum,
      deliveryrating: [{
        // ratedFor: RATING_STATUS_DECLARATION.statusOfDelivery.filter(list => list['selectItem']).map(filterList => filterList.name),
        ratedFor: this.selectedStatus,
        rating: this.ratingObj['deliveryRating'],
      }],
      foodRating: [{
        ratedFor: RATING_STATUS_DECLARATION.process.filter(list => list['selectItem']).map(filteredList => filteredList.name),
        rating: this.ratingObj['foodRating']
      }],
      comment: this.comments
    }

    this.orderService.rateOrder(reqBody).then((res) => {
      const obj = {
        rated: true,
        orderNum: this.outletObj.orderNum,
        rating: this.ratingObj['foodRating']
      }
      this.passRating.emit(obj);
      this.modalService.open(ThankyouForRatingModalComponent, getConfig('THANKSFOR_RATING_CONFIG'));
      setTimeout(() => {
        if (this.outletObj.navigateToHome) {
          this.router.navigate(['/home']);
        } else {
          this.modalService.dismissAll();
        }
      }, 2500);
    });
  }

  closeModal() {
    if (this.outletObj.navigateToHome) {
      this.router.navigate(['/home']);
    } else {
      this.modalService.dismissAll();
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      const divObj = document.getElementById('textarea');
      divObj.scrollIntoView(true);
    }, 1000);
  }

  onTextarea(event){
    console.log(event.target.value.length)
    if(event.target.value.length >=70){
      this.rows = 3;
    } else{
      this.rows= 0;
    }
  }

}
